import { styled } from 'styled-components';
import { BreakPoint } from 'styles/style-variables/breakpoint';
import { EColors } from 'styles/style-variables/colors';
import { FontFamily } from 'styles/style-variables/font-family';
import { TransitionTime } from 'styles/style-variables/transition-time';

export const TrialMinerLink = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  min-height: 50px;
  padding: 8px 24px;
  background-color: ${EColors.BlueGrayBackMid};
  font-family: ${FontFamily.Montserrat};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  text-decoration: none;
  color: ${EColors.Gray1Text};
  transition: background-color ${TransitionTime.Hover};

  &:focus-visible {
    outline: none;
  }

  &:hover,
  &:focus {
    background-color: ${EColors.SiteBack};
    cursor: pointer;
  }

  @media (max-width: ${BreakPoint.LaptopTop}) {
    padding: 16px;
    border-radius: 16px;
  }

  @media (max-width: ${BreakPoint.MobileTop}) {
    padding-right: 24px;
    padding-left: 24px;
    border-radius: 0;
  }
`;
